
import { v4 as uuidv4  } from "uuid";

const STORAGE_KEY = "chatbot_sessions";

const generateGuid = (): string => {
  return uuidv4();
};

const getSessionMap = (): Record<string, string> => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Record<string, string>) : {};
  } catch {
    return {};
  }
};

const saveSessionMap = (map: Record<string, string>): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
};

export const getSessionId = (datasetId: string): string => {
  const map = getSessionMap();
  if (!map[datasetId]) {
    map[datasetId] = generateGuid();
    saveSessionMap(map);
  }
  return map[datasetId];
};

export const clearSessionId = (datasetId: string): void => {
  const map = getSessionMap();
  delete map[datasetId];
  saveSessionMap(map);
};

export const renewSessionId = (datasetId: string): string => {
  const map = getSessionMap();
  map[datasetId] = generateGuid();
  saveSessionMap(map);
  return map[datasetId];
};
